import { Link as ScrollLink } from "react-scroll";
import st_hero from "./Hero.module.css";
import WindowDimensions from "hooks/useDimensions";

const Hero = () => {
  const isWeb = WindowDimensions();

  const MobBR = () => <>{!isWeb ? <br /> : null}</>;

  return (
    <section className={st_hero.section} id="hero">
      <div className={st_hero.text_container}>
        <h1 className={st_hero.title}>
          <span
            style={{
              color: "#54A3D9",
            }}
          >
            Angel Protocol{" "}
          </span>
          <MobBR />
          supports <br /> displaced
          <MobBR />
          <span
            style={{
              color: "#ffd700",
            }}
          >
            {" "}
            Ukrainians
          </span>
        </h1>
        <p className={st_hero.description}>
          Ongoing conflict has led to a humanitarian crisis in Ukraine that
          could displace over 7 million people. Fund relief & refugee efforts by
          donating crypto assets today
        </p>
        <ScrollLink
          className={st_hero.donate_now}
          to="donate_now"
          duration={500}
          spy={true}
          smooth={true}
        >
          Donate Now
        </ScrollLink>
      </div>
    </section>
  );
};

export default Hero;
